import { NavbarDropdownMenuColumnElement } from '@typedream/components';
import { ComponentProps, forwardRef } from 'react';
import styled from 'styled-components';
import { SettingButton } from './SettingButton';

type EmptyColumnPlaceholderProps = Omit<ComponentProps<
  typeof NavbarDropdownMenuColumnElement
>, 'children'> & { onAddMenuItem: (e: MouseEvent) => void };

const EmptyColumnPlaceholderRoot = styled.div`
  position: relative;
  align-self: stretch;
  border: 1px dashed var(--accent);
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 350px;
  min-height: 350px;
`;

export const EmptyColumnPlaceholder = forwardRef<
HTMLDivElement,
EmptyColumnPlaceholderProps
>((props, ref) => {
  // eslint-disable-next-line react/prop-types
  const { attributes, onAddMenuItem } = props;

  return (
    <EmptyColumnPlaceholderRoot
      ref={ref}
      {...attributes}
    >
      <SettingButton
        onClick={onAddMenuItem}
      >
        Add item inside
      </SettingButton>
    </EmptyColumnPlaceholderRoot>
  );
});
